import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { DisminucionBaseRendimientos} from './DisminucionBaseRendimientos.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'DisminucionBaseRendimientos',
        component: DisminucionBaseRendimientos,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'DisminucionBaseRendimientos'
        } 
    }
];

@NgModule({
    declarations: [
        DisminucionBaseRendimientos
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        DisminucionBaseRendimientos
    ],
    bootstrap: [DisminucionBaseRendimientos]
})

export class DisminucionBaseRendimientosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DisminucionBaseRendimientos/DisminucionBaseRendimientos.module.ts